// Strip repeated slashes so that the file path doesn't get derpy.
export const PATH_SEGMENT_SEPARATOR = '/';
export default function normalizePath(path: string): string {
  const re = new RegExp(PATH_SEGMENT_SEPARATOR + '{2,}', 'g');
  return path.replace(re, PATH_SEGMENT_SEPARATOR);
}
